import { 
	DEACTIVATE_FACULTY, ACTIVATE_FACULTY, CREATE_FACULTY, UPDATE_FACULTY, GET_ERRORS, GET_FACULTIES,  
} from "../actions/types";

const initialState = {
	actionType: '',
	faculties:  [],
	error:      {},
};

export default function (state = initialState, action) {
	switch (action.type) {
		case CREATE_FACULTY:
			return {
				...state,
				actionType: action.type,
				success:    'El permiso fue creado exitosamente.'
			};
		case UPDATE_FACULTY:
			return {
				...state,
				actionType: action.type,
				success:    'El permiso fue actualizado exitosamente.'
			};
		case GET_FACULTIES:
			return {
				...state,
				actionType: action.type,
				faculties:  action.payload.message,
				success:    'Se obtuvieron ' + action.payload.message.length + " permisos."
			};
		case DEACTIVATE_FACULTY:
			return {
				...state,
				actionType: action.type,
				success:    'El permiso fue desactivado exitosamente.'
			};
    case ACTIVATE_FACULTY:
      return {
        ...state,
        actionType: action.type,
        success:    'El permiso fue activado exitosamente.'
      };
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				message:    action.payload
			};
		default:
			return state;
	}
}